import React from 'react'
import * as S from '../../styles'

export const FourthRowWidgets = ({
  endPtSecurityAccessState,
  renderSecureFleetWidget
}) => {
  const renderFourthRow = () => {
    if (endPtSecurityAccessState) {
      return <S.Grid>{renderSecureFleetWidget}</S.Grid>
    }
    return null
  }

  return <>{renderFourthRow()}</>
}

export default FourthRowWidgets
